// extracted by mini-css-extract-plugin
export default {"overlayContainer":"LoadingOverlay_overlayContainer__bRs5q","loaderTitle":"LoadingOverlay_loaderTitle__Ub0i6"};